import classnames from "classnames"

import Icon from "components/Icon"

import styles from "./IconButton.module.scss"

type IconButtonProps = {
  className?: string
  value?: any
  disabled?: boolean
  icon?: any
  title?: string
  variant?: "ghost" | "solid" | "bare" | string
  onClick?: (e: any) => void
  onMouseDown?: any
  onMouseUp?: any
  onMouseLeave?: any
  name?: string
}

const IconButton = ({
  // variant: 'ghost' or 'solid' or 'bare'
  className,
  value,
  disabled,
  icon,
  title,
  variant = "ghost",
  onClick,
  onMouseDown,
  onMouseUp,
  onMouseLeave,
  name,
}: IconButtonProps) => {
  return (
    <button
      type="button"
      title={title}
      value={value}
      disabled={disabled}
      className={classnames(styles.button, styles[variant], className)}
      onClick={onClick}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseLeave}
      name={name}>
      <Icon className={styles.icon} icon={icon} />
    </button>
  )
}

export default IconButton
